module.exports = __webpack_public_path__ + "static/media/event3.cae78d4b.jpg";